import React, { createContext, useContext, useEffect, useState } from 'react'
import { publicApi } from '../api'
import type { PublicConfig } from '../api/types'

interface PublicConfigContextValue {
  appName: string
  backgroundImage: string | null
}

const PublicConfigContext = createContext<PublicConfigContextValue>({
  appName: 'family-vc',
  backgroundImage: null,
})

export function PublicConfigProvider({ children }: { children: React.ReactNode }) {
  const [appName, setAppName] = useState('family-vc')
  const [backgroundImage, setBackgroundImage] = useState<string | null>(null)

  useEffect(() => {
    void publicApi.config().then((cfg: PublicConfig) => {
      const name = cfg.appName || 'family-vc'
      setAppName(name)
      document.title = name
      if (cfg.backgroundImage) {
        setBackgroundImage(cfg.backgroundImage)
        document.documentElement.style.setProperty('--app-bg-image', `url("${cfg.backgroundImage}")`)
        document.documentElement.classList.add('has-bg')
      } else {
        document.documentElement.style.removeProperty('--app-bg-image')
        document.documentElement.classList.remove('has-bg')
      }
    }).catch(() => {/* pre-setup, ignore */})
  }, [])

  return (
    <PublicConfigContext.Provider value={{ appName, backgroundImage }}>
      {children}
    </PublicConfigContext.Provider>
  )
}

export function usePublicConfig() {
  return useContext(PublicConfigContext)
}
